import { Input } from '@agro-club/agroclub-shared'
import { CurrencyCode } from 'modules/domain/export/types'
import { FormikFieldsType } from 'modules/domain/types'
import { FC } from 'react'
import styled from 'styled-components'
import { FormCurrencySelect } from 'views/components/FormCurrencySelect/FormCurrencySelect'

const options = [
  {
    value: CurrencyCode.USD,
    label: 'USD, $/т',
  },
  {
    value: CurrencyCode.EUR,
    label: 'EUR, €/т',
  },
  {
    value: CurrencyCode.RUB,
    label: 'RUB, ₽/т',
  },

  {
    value: CurrencyCode.AED,
    label: 'AED, DN/т',
  },
  {
    value: CurrencyCode.CNY,
    label: 'CNY, ¥/т',
  },
]

const Controls = styled.div`
  display: grid;
  grid-template-columns: 94px 160px;
  gap: 8px;
`

type Props = {
  formik: FormikFieldsType
  inputField: string
  currencyField: string
}

export const PriceUnitSelect: FC<Props> = ({ formik, inputField, currencyField }) => {
  return (
    <Controls>
      <Input type="number" {...formik.getFieldProps(inputField)} />
      <FormCurrencySelect formik={formik} field={currencyField} options={options} />
    </Controls>
  )
}
